import React, { useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap";

import { ConvertDate } from "../../../Function/ConvertDate";
import { GetCookieData, GetCookieToken } from "../../../Cookie/GetCookie";
import axios from "axios";
import Lottie from "react-lottie";
import * as deleteTrash from "../../../../assets/lottieAnimation/delete.json";
import { CheckBudgetYear } from "../../../Function/CheckBudgetYear";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import { Tooltip } from "@mui/material";
import SubMenuEntryWork from "../../SubMenuEntryWork";
import MyThaiDatePick from "../../../../components/Common/ThaiDatePicker";
import { CheckSubAdmin } from "../../../Function/CheckSubAdmin";
import { CheckPosition } from "../../../Function/CheckPosition";
import classnames from "classnames";
import SelectOrg from "../../selectOrg/selectOrg";
import NewThaiDatePicker from "../../../../components/Common/NewThaiDatePicker";

const EmployeeView = ({ userInfoProps }) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user?.user_id;
  const budgetYear = CheckBudgetYear();

  const [holiday, setHoliday] = useState([]);
  const [dataForm16, setDataForm16] = useState([]);
  const [dataEdit, setDataEdit] = useState({});
  const [currentPage, setCurrentPage] = useState();
  const [totalPage, setTotalPage] = useState();
  const [totalRows, setTotalRows] = useState();
  const [modal, setModal] = useState(false);
  const [confirmSend, setConfirmSend] = useState(false);
  const [modalCancel, setModalCancel] = useState({
    modal: false,
    status: "",
  });
  const [data, setData] = useState({
    //show in form only
    user_id: userInfoProps?.user_id,
    user_name: userInfoProps?.user_name,
    user_position_name: userInfoProps?.user_position_name,
    cont_to_name_1: userInfoProps?.cont_to_name_1,
    writeFrom: "สำนักงาน ก.พ.ร.",
    writeDate: new Date().toLocaleDateString(),

    //required field
    leave_type_id: 16,
    form_type: 12,
    form_name: "ออกงานก่อนเวลา",
    budget_year: budgetYear,
    leave_name: "ขออนุญาตออกงานก่อนเวลา",
    send_to: "ผู้อำนวยการสำนักงานเลขาธิการ",
    leave_from_date: new Date(new Date().setHours(0, 0, 0, 0)),
    leave_from_timetype: "1",
    leave_to_date: new Date(new Date().setHours(0, 0, 0, 0)),
    leave_to_timetype: "2",
    leave_days: null,
    leave_status: "4",
    approve_status: "0",
    approve_user_id: userInfoProps?.leader?.user_id,
    approve_user: userInfoProps?.leader?.user_name,
    leave_reason: "",
  });
  const [position, setPosition] = useState(false)
  const [searchData, setSearchData] = useState({
    startDate: new Date(),
    toDate: new Date(),
    department: "",
    groupName: "",
    empName: "",
    empNamID: "",
    fileType: "1",
    reportType: "1",
  });
  const [orgInnerKong, setOrgInnerKong] = useState([]);
  const [orgInnerGroup, setOrgInnerGroup] = useState([]);
  const [checkValueOrgKong, setCheckValueOrgKong] = useState([]);
  const [checkValueOrgGroup, setCheckValueOrgGroup] = useState([]);
  const [checkValueUniqueOrgKong, setCheckValueUniqueOrgKong] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [checkDisable, setCheckDisble] = useState(true);
  const [checkDisableGroup, setCheckDisbleGroup] = useState(true);
  const [checkDisableUser, setCheckDisbleUser] = useState(true);

  const getOrgInnerKong = async () => {
    try {
      const res = await axios.get(baseURL + `/api/orgInner/level`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOrgInnerKong(res?.data?.result?.child);
    } catch (err) {
      console.error(err);
    }
  };
  
  useEffect(() => {
    getEmployee();
    getOrgInnerKong();
  }, []);

  useEffect(() => {
    const uniqueDataSet = [...new Set(checkValueOrgKong)];
    setCheckValueUniqueOrgKong(uniqueDataSet);
  }, [checkValueOrgKong]);

  // useEffect(() => {
  //   getEmployee();
  // }, [keyword]);

  const getEmployee = async (id) => {
    let OrgId = id || "";
    try {
      const url = baseURL + "/api/users/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 1000,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_name_status][0]": "ปกติ",
        "filter[cont_to_id][0]": OrgId,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setEmployee(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };


  const findByOrgKong = (id) => {
    setOrgInnerGroup(
      orgInnerKong.find((item) => item.org_id === parseInt(id))?.child
    );
  };

  const findByOrgGroup = (id) => {
    let anw = orgInnerKong?.find((i) =>
      i?.child?.find((j) => Number(j?.org_id) === Number(id))
    )?.org_id;

    setCheckValueOrgKong((prev) => [...prev, anw]);

    // setOrgInnerGroup(

    let newobject = {
      org_id: id,
      parent_id: anw,
    };

    setCheckValueOrgGroup((prev) => [...prev, newobject]);
  };

  const findEmployeeOfKong = (id) => {
    if (id) {
      setEmployee([]);
      let ArrayGroupId =
        orgInnerKong.find((item) => item.org_id === parseInt(id))?.child
          ?.length === 0
          ? id
          : orgInnerKong.find((item) => item.org_id === parseInt(id))?.child;
      if (Array.isArray(ArrayGroupId)) {
        ArrayGroupId?.map((item) => {
          getEmployeeByKongID(item?.org_id);
        });
      } else {
        getEmployeeByKongID(ArrayGroupId);
      }
    }
  };

  const getEmployeeByKongID = async (ArrayGroupId) => {
    try {
      const url = baseURL + "/api/users/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 100,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_name_status][0]": "ปกติ",
        "filter[cont_to_id][0]": ArrayGroupId,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      res?.data?.result?.map((item) => {
        setEmployee((prev) => [...prev, item]);
      });
    } catch (err) {
      console.error(err);
    }
  };

  const findEmployeeOfGroup = (id) => {
    if (id) {
      setEmployee([]);
      getEmployeeByGroupID(id);
    }
  };

  const getEmployeeByGroupID = async (ArrayGroupId) => {
    try {
      const url = baseURL + "/api/users/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 100,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_name_status][0]": "ปกติ",
        "filter[cont_to_id][0]": ArrayGroupId,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      res?.data?.result?.map((item) => {
        setEmployee((prev) => [...prev, item]);
      });
    } catch (err) {
      console.error(err);
    }
  };

  const getHoliday = async (year) => {
    try {
      const res = await axios.get(baseURL + `/api/masterdata/holiday/${year}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      setHoliday(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      leave_days: calculateLeaveDays(
        data?.leave_from_date,
        data?.leave_from_timetype,
        data?.leave_to_date,
        data?.leave_to_timetype
      ),
    }));
    getHoliday(new Date()?.getFullYear());
  }, []);

  useEffect(() => {
    if (userInfoProps) {
      setData((prev) => ({
        ...prev,
        //show in form only
        user_id: userInfoProps?.user_id,
        user_name: userInfoProps?.user_name,
        user_position_name: userInfoProps?.user_position_name,
        cont_to_name_1: userInfoProps?.cont_to_name_1,
        writeFrom: "สำนักงาน ก.พ.ร.",
        writeDate: new Date().toLocaleDateString(),

        //required field
        leave_type_id: 16,
        form_type: 12,
        form_name: "ออกงานก่อนเวลา",
        budget_year: budgetYear,
        leave_name: "ขออนุญาตออกงานก่อนเวลา",
        send_to: "ผู้อำนวยการสำนักงานเลขาธิการ",
        leave_from_date: new Date(new Date().setHours(0, 0, 0, 0)),
        leave_from_timetype: "1",
        leave_to_date: new Date(new Date().setHours(0, 0, 0, 0)),
        leave_to_timetype: "2",
        leave_days: calculateLeaveDays(
          new Date(new Date().setHours(0, 0, 0, 0)),
          "1",
          new Date(new Date().setHours(0, 0, 0, 0)),
          "2"
        ),
        leave_status: "4",
        approve_status: "0",
        approve_user_id: userInfoProps?.leader?.user_id,
        approve_user: userInfoProps?.leader?.user_name,
        leave_reason: "",
      }));
      if (CheckSubAdmin(userInfoProps?.positionSubAdmin)) {
        setPosition("admin")
      } else if (CheckPosition(userInfoProps?.position)) {
        setPosition("leader")
        if (userInfoProps.position.length > 0) {
        userInfoProps.position.map((item) => {
          if (Number(item.position_id) === 5) {
            setCheckValueOrgKong((prev) => [...prev, item.org_id]);
            setCheckDisble(false);
            findByOrgKong(item.org_id);
            findEmployeeOfKong(item.org_id);
          }

          if (Number(item.position_id) === 7) {
            setCheckDisble(false);
            setCheckDisbleGroup(false);
            setCheckDisbleUser(false);
            findByOrgGroup(item.org_id);
          }

          if (Number(item.position_id) === 8) {
            setSearchData((prev) => ({
              ...prev,
              empName: userInfoProps.user_id,
              empNamID: userInfoProps.user_name,
            }));
          }
        });
      } else {
        setSearchData((prev) => ({
          ...prev,
          empName: userInfoProps.user_id,
          empNamID: userInfoProps.user_name,
        }));
      }
      } else {
        setPosition("normol");
      }
      
    }
  }, [userInfoProps]);

  const calculateLeaveDays = (
    leavefromDate,
    leavefromTime,
    leavetoDate,
    leavetoTime
  ) => {
    let sum = 0;

    const isWeekend = (date) => {
      const day = new Date(date)?.getDay();
      return day === 6 || day === 0; // 6 คือวันเสาร์, 0 คือวันอาทิตย์
    };

    const isThaiPublic = (date) => {
      const localDate = new Date(date);
      localDate.setHours(0, 0, 0, 0);
      return holiday.some((item) => {
        const startDate = new Date(item?.date_start_holiday)?.setHours(
          0,
          0,
          0,
          0
        );
        const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
        return localDate >= startDate && localDate <= endDate;
      });
    };

    if (leavefromTime === "1" && leavetoTime === "2") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 0;
      return sum;
    }
    if (leavefromTime === "1" && leavetoTime === "1") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 0.5;
      return sum;
    }
    if (leavefromTime === "2" && leavetoTime === "2") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 0.5;
      return sum;
    }
    if (leavefromTime === "2" && leavetoTime === "1") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 1;
      return sum;
    }
  };

  const toggleConfirm = () => {
    setConfirmSend(!confirmSend);
  };

  const toggleModal = () => {
    if (modal === true) {
      setDataEdit({});
      setModal(!modal);
    } else {
      setModal(!modal);
    }
  };

  const [insertModal, setInsertModal] = useState(false)

  const handleSubmit = async () => {
    try {
      const res = await axios.post(
        `${baseURL}/api/leave/save`,
        {
          leave_type_id: data?.leave_type_id, //ประเภทใบลา
          form_type: data?.form_type, //ประเภทฟอร์มการลา
          form_name: data?.form_name, //ชื่อฟอร์มการลา
          budget_year: data?.budget_year, //ปีงบประมาณ
          leave_name: data?.leave_name, //ชื่อเรื่องการลา
          send_to: data?.send_to, //เรียน
          leave_from_date: ConvertDate(data?.leave_from_date)?.toDateISO(), //ตั้งแต่วันที่
          leave_from_timetype: data?.leave_from_timetype, //ช่วงเวลา
          leave_to_date: ConvertDate(data?.leave_to_date)?.toDateISO(), //ถึงวันที่
          leave_to_timetype: data?.leave_to_timetype, //ช่วงเวลา
          leave_days: data?.leave_days, //กำหนดหรือจำนวนวัน

          leave_reason: data?.leave_reason,
          note: data?.note || "", //หมายเหตุ
          user_id: data?.user_id, //ไอดีผู้ส่งฟอร์ม
          leave_status: data?.leave_status, //สถานะใบลา
          approve_status: data?.approve_status, //สถานะการอนุมัติ
          approve_user_id: data?.approve_user_id,
          approve_user: data?.approve_user,
          approve_final: 0,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await getForm16DataTable();
      toggleConfirm();
      setData((prev) => ({
        ...prev,
        form_type: 12,
        form_name: "ออกงานก่อนเวลา",
        budget_year: CheckBudgetYear(),
        leave_name: "ขออนุญาตออกงานก่อนเวลา",
        send_to: "ผู้อำนวยการสำนักงานเลขาธิการ",
        leave_from_date: new Date(new Date().setHours(0, 0, 0, 0)),
        leave_from_timetype: "1",
        leave_to_date: new Date(new Date().setHours(0, 0, 0, 0)),
        leave_to_timetype: "2",
        leave_days: calculateLeaveDays(
          new Date(new Date().setHours(0, 0, 0, 0)),
          "1",
          new Date(new Date().setHours(0, 0, 0, 0)),
          "2"
        ),
        leave_reason: "",
      }));
      setInsertModal(false)
    } catch (err) {
      console.error(err);
    }
  };


//   useEffect(() => {
//   }, [userInfoProps])
  

  const [filter,setfilter] = useState({
    fromDate : null,
    toDate : null,
    isValid : false,
    userId : null,
  })

  const [userIdArray,setUserIdArray] = useState([])

  const getForm16DataTable = async (pages = 1) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: pages,
        size: 5,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[leave_type_id][0]": 16,
      });
      if (searchData?.empName) {
        // params.append("filter[user_id][0]", filter.userId);
        params.append("filter[user_id][0]", searchData?.empName);
      } else {
        userIdArray || userIdArray.forEach((item,index) => {
        params.append(`filter[user_id][${index}]`, item);
      });
      }
      
      //filter.userId && params.append("filter[user_id][0]", filter.userId);
      filter.fromDate && params.append("filter[leave_dmy_start][0]", filter.fromDate);
      filter.toDate && params.append("filter[leave_dmy_end][0]", filter.toDate);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      
      const res = await axios.get(url, config);
      setDataForm16(res?.data?.result);
      setCurrentPage(res?.data?.info?.currentPage);
      setTotalPage(res?.data?.info?.totalPage);
      setTotalRows(res?.data?.info?.totalRows);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getForm16DataTable();
  }, []);

  const resetData = () => {
    setData((prev) => ({
      ...prev,
      user_id: userInfoProps?.user_id,
      user_name: userInfoProps?.user_name,
      user_position_name: userInfoProps?.user_position_name,
      cont_to_name_1: userInfoProps?.cont_to_name_1,
      writeFrom: "สำนักงาน ก.พ.ร.",
      writeDate: new Date().toLocaleDateString(),

      //required field
      leave_type_id: 16,
      form_type: 12,
      form_name: "ออกงานก่อนเวลา",
      budget_year: CheckBudgetYear(),
      leave_name: "ขออนุญาตออกงานก่อนเวลา",
      send_to: "ผู้อำนวยการสำนักงานเลขาธิการ",
      leave_from_date: new Date(new Date().setHours(0, 0, 0, 0)),
      leave_from_timetype: "1",
      leave_to_date: new Date(new Date().setHours(0, 0, 0, 0)),
      leave_to_timetype: "2",
      leave_days: calculateLeaveDays(
        new Date(new Date().setHours(0, 0, 0, 0)),
        "1",
        new Date(new Date().setHours(0, 0, 0, 0)),
        "2"
      ),
      leave_status: "4",
      approve_status: "0",
      approve_user_id: userInfoProps?.leader?.user_id,
      approve_user: userInfoProps?.leader?.user_name,

      //non required field
      leave_reason: "",
      contact_address: "",
      abroad_for: "",
      abroad_country: "",
      abroad_ref: "",
      abroad_ref_2: "",
      ordinate_ever: "",
      ordinate_temple: "",
      ordinate_temple_place: "",
      ordinate_date: "",
      ordinate_live_temple: "",
      ordinate_live_place: "",
      hujj_ever: "",
      conscription_from: "",
      conscription_place: "",
      conscription_date: "",
      conscription_for: "",
      conscription_to_place: "",
      training_fund_from: "",
      spouse_name: "",
      spouse_position: "",
      spouse_department: "",
      spouse_country: "",
      spouse_from_date: "",
      spouse_to_date: "",
      spouse_years: "",
      spouse_months: "",
      spouse_days: "",
      outside_place: "",
      practice_type: "",
      practice_reason: "",

      note: "",
    }));
  };

  const handleCancelLeave = async (id, status) => {
    try {
      const res = await axios.put(
        baseURL + `/api/leave/${id}`,
        {
          leave_type_id: dataEdit?.leave_type_id,
          form_type: dataEdit?.form_type,
          form_name: dataEdit?.form_name,
          budget_year: dataEdit?.budget_year,
          leave_name: dataEdit?.leave_name,
          send_to: dataEdit?.send_to,
          leave_from_date: dataEdit?.leave_from_date,
          leave_from_timetype: dataEdit?.leave_from_timetype,
          leave_to_date: dataEdit?.leave_to_date,
          leave_to_timetype: dataEdit?.leave_to_timetype,
          leave_days: dataEdit?.leave_days,
          user_id: dataEdit?.user_id,
          leave_reason: dataEdit?.leave_reason,
          leave_status: status,
          approve_status: dataEdit?.approve_status,
          approve_user_id: dataEdit?.approve_user_id,
          approve_user: dataEdit?.approve_user,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await toggleModalCancel();
      await getForm16DataTable();
    } catch (err) {
      console.error(err);
    }
  };

  const toggleModalCancel = (status) => {
    if (modalCancel?.modal === false) {
      setModalCancel((prev) => ({
        ...prev,
        modal: true,
        status: status,
      }));
    } else {
      setModalCancel((prev) => ({
        ...prev,
        modal: false,
        status: "",
      }));
    }
  };

  // const [, setViewSubMenu] = useState();
  // const [viewSubMenu, setViewSubMenu] = useState();

  // useEffect(() => {
  //   setViewSubMenu(
  //     CheckSubAdmin(userInfoProps?.positionSubAdmin) ||
  //       CheckPosition(userInfoProps?.position)
  //   );
  // }, [userInfoProps]);

  const setFromDate = (e) => {
    setfilter(prev => ({
      ...prev,
      fromDate : e
    }));
  }

  const setToDate = (e) => {
    setfilter(prev => ({
      ...prev,
      toDate : e
    }));
  }

  function filterForm() {
    return <Row className="pb-2">
    <Col>
      <Label>ตั้งแต่วันที่</Label>
      <MyThaiDatePick invalidProps = {filter.isValid && filter.fromDate === null ? true : false} setDateObj = {setFromDate}/>
    </Col>
    <Col>
      <Label>ถึงวันที่</Label>
      <MyThaiDatePick minDate={filter.fromDate} setDateObj = {setToDate}/>
    </Col>
    <Col className="d-flex align-items-end">
    <Button className="btn-success me-1" 
      onClick={(e) => {
        e.preventDefault();
          setfilter(prev => ({
            ...prev,
            isValid : true
          }));
        filter.isValid && filter.fromDate && getForm16DataTable();
      }}>
        <i className="fa-sharp fa-solid fa-magnifying-glass pe-1"></i>ค้นหา
        </Button>
    </Col>
  </Row>
  }

  const setDivisionOrgObj = (event) =>{
    setSearchData((prev) => ({
      ...prev,
      department: event,
    }));
  }

  const setGroupOrgObj = (event) =>{
    setSearchData((prev) => ({
      ...prev,
      groupName: event,
    }));
  }

  const setUserOrgObj = (event) =>{
    setSearchData((prev) => ({
      ...prev,
      empName: event,
    }));
  }

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function positionFilterForm() {
    return      <Row className="pb-2">
                  <Col>
                    <Form>
                      <SelectOrg setDivisionOrg={setDivisionOrgObj} setGroupOrg={setGroupOrgObj} setUserOrg={setUserOrgObj} />
                      <FormGroup row style={{ display: "flex", justifyContent: "end" }}>
                        <Label className="text-end"  md={1} xxl={2}>
                          ค้นหาช่วงวันที่
                        </Label>
                        <Col xs={12} md={4} xl={3}>
                          <InputGroup className={` 
                            ${windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) || (windowSize.width >= 992 && windowSize.width < 1200 )
                              ? "d-flex justify-content-end mb-2" 
                              : ""}`}
                          >
                            <InputGroupText>ตั้งแต่วันที่</InputGroupText>
                            <MyThaiDatePick placeholderText = "วัน/เดือน/ปี" invalidProps = {filter.isValid && filter.fromDate === null ? true : false} setDateObj = {setFromDate} showClearButton={true}/>
                          </InputGroup>
                        </Col>
                        <Col xs={12} md={4} xl={3}>
                          <InputGroup className={` 
                            ${windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) || (windowSize.width >= 992 && windowSize.width < 1200 )
                              ? "d-flex justify-content-end mb-2" 
                              : ""}`}
                          >
                            <InputGroupText>ถึงวันที่</InputGroupText>
                            <MyThaiDatePick minDate={filter.fromDate} placeholderText = "วัน/เดือน/ปี" setDateObj = {setToDate} showClearButton={true}/>
                          </InputGroup>
                        </Col>
                        <Col xs={12} md={2} xl={2} className="d-flex justify-content-end">
                          <Button className="btn-success me-1 " 
                            style={{width:"170px"}}
                            onClick={(e) => {
                              e.preventDefault();
                                setfilter(prev => ({
                                  ...prev,
                                  isValid : true
                                }));
                              filter.isValid && filter.fromDate && getForm16DataTable();
                            }}>
                              <i className="fa-sharp fa-solid fa-magnifying-glass pe-1"></i>ค้นหา
                          </Button>
                        </Col>
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>
  }

  const [modalSelectUser, setModalSelectUser] = useState(false);

  const toggleSelectUserModal = () => {
    setModalSelectUser(!modalSelectUser);
    // getUserEmployee(cont_to_id);
  };

  function selectUserModal(){
    return <Modal centered isOpen={modalSelectUser} toggle={toggleSelectUserModal}>
    <ModalHeader toggle={toggleSelectUserModal}>เลือกเจ้าหน้าที่</ModalHeader>
    <ModalBody>
      <FormGroup>
        <Col>
          <Input
            value={searchData?.empName}
            style={{ height: "400px" }}
            multiple
            type="select"
            onChange={(e) => {
              setSearchData((prev) => ({
                  ...prev,
                  empName: e.target.value,
                  empNamID: e.target.options[e.target.selectedIndex].text,
                }));
              setfilter((prev) => ({
                ...prev,
                userId: e.target.value
              }))
              setModalSelectUser(false);
            }}
          >
            {employee?.map((item) => {
              return (
                <option key={item?.user_id} value={item?.user_id}>
                  {item?.user_name}
                </option>
              );
            })}
          </Input>
        </Col>
      </FormGroup>
    </ModalBody>
  </Modal>
  }

  return (
    <React.Fragment>
    {selectUserModal()}
    <Row className="mt-3">
                  <Col className="h-100">
                    {/* {filterForm()} */}
                    {position === "leader" || position === "admin" ? positionFilterForm() : filterForm()}
                    <Table responsive style={{ verticalAlign: "middle" }}>
                      <thead className="table-light">
                        <tr>
                          <th className="text-center">ลำดับ</th>
                          {/* <th>ชื่อฟอร์ม</th> */}
                          <th className="text-center">ตั้งแต่วันที่</th>
                          <th className="text-center">ถึงวันที่</th>
                          <th>เหตุผล</th>
                          <th className="text-center">สถานะ</th>
                          <th className="text-center">เจ้าหน้าที่</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataForm16?.length > 0 ?
                          dataForm16?.map((item, idx) => {
                            let startDate = ConvertDate(
                              item?.leave_from_date
                            ).toThaiDateDMY();
                            let endDate = ConvertDate(
                              item?.leave_to_date
                            ).toThaiDateDMY();

                            let status_leave = "";
                            if (item?.leave_status === "0")
                              status_leave = "อนุมัติ";
                            if (item?.leave_status === "2")
                              status_leave = "รออนุมัติ";
                            if (item?.leave_status === "3")
                              status_leave = "รออนุมัติ";
                            if (item?.leave_status === "4")
                              status_leave = "รออนุญาต";
                            if (item?.leave_status === "5")
                              status_leave = "อนุมัติ";
                            if (item?.leave_status === "6")
                              status_leave = "ไม่อนุมัติ";
                            if (item?.leave_status === "7")
                              status_leave = "ขอยกเลิกใบลา";
                            if (item?.leave_status === "8")
                              status_leave = "ยกเลิก";
                            if (item?.leave_status === "9")
                              status_leave = "ส่งกลับแก้ไข";
                            if (item?.leave_status === "A")
                              status_leave = "อนุมัติยกเลิก";
                            if (item?.leave_status === "B")
                              status_leave = "ไม่อนุมัติยกเลิก";
                            if (item?.status_leave === null)
                              status_leave = "ไม่มีข้อมูล";

                            return (
                              <tr key={idx}>
                                <td className="text-center">{idx + 1}</td>
                                {/* <td>{item?.leave_name}</td> */}
                                <td className="text-center">{startDate}</td>
                                <td className="text-center">{endDate}</td>
                                <td>{item?.leave_reason}</td>
                                <td className="text-center">
                                  <h5>
                                    <Badge
                                      pill
                                      color={
                                        item?.leave_status === "0" ||
                                        item?.leave_status === "3" ||
                                        item?.leave_status === "5" ||
                                        item?.leave_status === "A"
                                          ? "success"
                                          : item?.leave_status === "2" ||
                                            item?.leave_status === "4"
                                          ? "primary"
                                          : item?.leave_status === "6" ||
                                            item?.leave_status === "B" ||
                                            item?.leave_status === "9"
                                          ? "warning"
                                          : item?.leave_status === "8"
                                          ? "danger"
                                          : "secondary"
                                      }
                                    >
                                      {status_leave}
                                    </Badge>
                                  </h5>
                                </td>
                                <td>{item?.created_user}</td>
                              </tr>
                            );
                          })
                        :
                          <tr>
                            <td colSpan={8} className="text-center fs-5">
                              ไม่มีข้อมูล
                            </td>
                          </tr>
                        }
                      </tbody>
                    </Table>
                  </Col>
                </Row> 
                <Row
                    className="mx-2"
                    style={{
                      display: "flex",
                      alignItems: "end",
                    }}
                  >
                    <Col xxl={4} className="mb-2">
                      <h4>
                        <Badge className="badge-soft-primary me-1">
                          ทั้งหมด {totalRows} รายการ
                        </Badge>
                      </h4>
                    </Col>
                    <Col xxl={8} className="d-flex justify-content-end">
                      <Pagination aria-label="Page navigation example">
                        <PaginationItem disabled={currentPage === 1}>
                          <PaginationLink onClick={() => getForm16DataTable(1)}>
                            หน้าแรก
                          </PaginationLink>
                        </PaginationItem>
                        <PaginationItem disabled={currentPage === 1}>
                          <PaginationLink
                            onClick={() => getForm16DataTable(currentPage - 1)}
                          >
                            ย้อนกลับ
                          </PaginationLink>
                        </PaginationItem>
                        <PaginationItem active>
                          <PaginationLink>
                            หน้า {currentPage} จาก {totalPage}
                          </PaginationLink>
                        </PaginationItem>
                        <PaginationItem disabled={currentPage === totalPage}>
                          <PaginationLink
                            onClick={() => getForm16DataTable(currentPage + 1)}
                          >
                            ถัดไป
                          </PaginationLink>
                        </PaginationItem>
                        <PaginationItem disabled={currentPage === totalPage}>
                          <PaginationLink
                            onClick={() => getForm16DataTable(totalPage)}
                          >
                            หน้าสุดท้าย
                          </PaginationLink>
                        </PaginationItem>
                      </Pagination>
                    </Col>
                </Row>
    </React.Fragment>
  );
};

export default EmployeeView;
